export const userTeamVisibilities = [
  'visible',
  'hidden',
  'blacklisted',
] as const

type UserTeamVisibility = typeof userTeamVisibilities[number]
export default UserTeamVisibility
